import React, { useEffect, useState } from "react";
import { Modal, ModalFooter, ModalHeader, ModalBody } from "reactstrap";
import SpinningWheel from "~/components/spinningWheel";
import WheelService  from "~/services/spinningWheel";


const TokensWheelModal = ({refresh, isModalOpen, setIsModalOpen})=> {

  const [prize          , setPrize]          = useState(null);
  const [showPrize      , setShowPrize]      = useState(false);
  const [rewards        , setRewards]        = useState([]);
  const [disabledButton , setDisabledButton] = useState(false);
  const [hasTokenClaim  , setHasTokenClaim]  = useState(true);

  useEffect(()=> {
    (async ()=> {
      const res = await WheelService.hasTodayTokensClaims()
      if(!res) setRewards(await WheelService.getTokensPrizes());
      setHasTokenClaim(res);
    })();
  }, [isModalOpen]);

  const closeModal = ()=> {
    refresh();
    setIsModalOpen(false);
  };

  const handleSpinButton = async ()=> {
    setDisabledButton(true);
    setPrize(await WheelService.getTokensPrize());
  };

  return (
    <Modal isOpen={isModalOpen} toggle={closeModal} centered>

      <ModalHeader toggle={closeModal}> Win Game Tokens </ModalHeader>

      <ModalBody style={{textAlign: "center"}}>
        { hasTokenClaim
          ? <strong> Come back tomorrow for another chance! </strong>
          : <SpinningWheel rewards={rewards} prize={prize} onDone={()=> setShowPrize(true)} />
        }

        { !hasTokenClaim && <>
            {!showPrize && <p>
              You can win daily tokens by spinning the lucky wheel! <br/>
              Use the tokens to unlock extra game tasks every day!
            </p> }
            { showPrize && <p className="text-success"><strong> Congratulation, you have won: {prize} Tokens! </strong></p> }
          </>
        }
      </ModalBody>

      <ModalFooter className="jc-center">
        {(!disabledButton && !hasTokenClaim) &&<button className="btn btn-success pull-left" onClick={handleSpinButton} disabled={disabledButton}> Spin </button>}
        {(disabledButton || hasTokenClaim) && <button className="btn btn-danger pull-left" onClick={closeModal}> Cancel </button>}
      </ModalFooter>

    </Modal>
  );

}

export default TokensWheelModal;
